import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            flexGrow: 1,
            flexShrink: 1,
        },
        chart: {
            height: 350,
            marginTop: theme.spacing(0.5),
        },
    }
})

export default useStyles
